<template>
  <v-form
    :value="valid"
    @input="v => $emit('update:valid', v)"
    @submit.prevent=""
  >
    <v-row align="center" dense class="mb-2">
      <v-col cols="12">
        <v-checkbox
          hide-details
          v-model="getUseExpirationDateModel"
          label="Utiliser une durée d'expiration"
        ></v-checkbox>
      </v-col>
    </v-row>
    <section v-if="getUseExpirationDateModel === true">
      <v-row align="center" dense>
        <v-col cols="12" sm="4">
          <j-decimal-input
            hide-details
            filled
            dense
            class="no-before"
            :value="expiration_date_timer"
            :min="0"
            :step="0"
            :decimal="0"
            :required="getUseExpirationDateModel === true"
            label="Nombre de jours avant expiration"
            @change="v => $emit('update:expiration_date_timer', v)"
          ></j-decimal-input>
        </v-col>
        <v-col cols="12" sm="4">
          <j-decimal-input
            hide-details
            filled
            dense
            class="no-before"
            :value="expiration_date_threshold"
            :min="0"
            :step="0"
            :decimal="0"
            :required="getUseExpirationDateModel === true"
            label="Nombre de jours avant alerte"
            @change="v => $emit('update:expiration_date_threshold', v)"
          ></j-decimal-input>
        </v-col>
        <v-col cols="12" sm="4" align-self="center">
          <v-checkbox
            v-model="getUseAutoExpirationWasteModel"
            label="Créer une perte à l'expiration"
          ></v-checkbox>
        </v-col>
      </v-row>
    </section>
  </v-form>
</template>

<script>
export default {
  name: "ProductExpirationFields",
  props: {
    use_expiration_date: {
      required: true
    },
    expiration_date_timer: {
      required: true
    },
    expiration_date_threshold: {
      required: true
    },
    use_auto_expiration_waste: {
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    getUseAutoExpirationWasteModel: {
      get() {
        return this.use_auto_expiration_waste;
      },
      set(v) {
        this.$emit("update:use_auto_expiration_waste", v);
      }
    },
    getUseExpirationDateModel: {
      get() {
        return this.use_expiration_date;
      },
      set(v) {
        this.$emit("update:use_expiration_date", v);
      }
    }
  }
};
</script>

<style></style>
